import { LT_LIFESTYLE_EXPENSES_DATA_RECEIVED, LT_LIFESTYLE_EXPENSE_UNLOADED, LT_LIFESTYLE_EXPENSE_SAVED, LT_LIFESTYLE_EXPENSE_DELETED } from './types';

export default function lifestyle_expenses(state = [], action = {}){
  switch (action.type) {
    case LT_LIFESTYLE_EXPENSES_DATA_RECEIVED:
    return action.data.sort(function(a, b) {
      let result = 0 
      result =  (a.itemType.localeCompare(b.itemType)) || (parseInt(a.balance, 10) - parseInt(b.balance, 10)) || (a.description.localeCompare(b.description))
      return result
    })
    case LT_LIFESTYLE_EXPENSE_UNLOADED:
      return []
    case LT_LIFESTYLE_EXPENSE_SAVED:
      let isEdit = false
      const _state = state.map( v => {
        if(v.id === action.data.id){
          isEdit = true
          return action.data
        }else{
          return v
        }
      })
      if(!isEdit){
        return [action.data, ...state]
      }else{
        return _state
      }
    case LT_LIFESTYLE_EXPENSE_DELETED:
      return state.filter( v => v.id !== action.data.id )
    default:
      return state;
  }
}
